import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import LandingPaths from "@/components/LandingPaths";
import Marquee from "@/components/Marquee";
import Footer from "@/components/Footer";
import BookingModal from "@/components/BookingModal";
import { useLenis, useHashScroll } from "@/hooks/usePageUtils";

const Home = () => {
  useLenis();
  useHashScroll();

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <LandingPaths />
        <Marquee />
      </main>
      <Footer />
      <BookingModal />
    </>
  );
};

export default Home;
